/**
 * Auth Guard для защиты маршрутов
 * Аналог lib/app/router/role_guard.dart (CrmGuard)
 *
 * DEV-1253. Здесь остался только вопрос «залогинен ли»: раскладку по разделам
 * ведёт section.guard по карте с сервера. Ролевые гарды (hosOrAdmin, adminGuard,
 * agentSupport) и агентские (agentGuard, agentGuestGuard — портал уехал в
 * agents-vue ещё в DEV-1014) удалены вместе со своими beforeEnter.
 */
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useAuthStore } from '../stores/auth.store'

/**
 * Проверка аутентификации перед переходом на защищенные маршруты.
 */
export const authGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const authStore = useAuthStore()

  // Public routes (no auth required)
  const publicRoutes = ['/login', '/']

  if (publicRoutes.includes(to.path)) {
    next()
    return
  }

  // Check if authenticated
  if (!authStore.isAuthenticated) {
    next({
      path: '/login',
      query: { redirect: to.fullPath },
    })
    return
  }

  // Allow access
  next()
}

/**
 * Redirect authenticated users away from login page
 */
export const guestGuard = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const authStore = useAuthStore()

  if (authStore.isAuthenticated) {
    // Already logged in, redirect to dashboard
    next('/dashboard')
    return
  }

  next()
}
